<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name(:class="{ 'non-active-font': !active }") 面会スケジュールの単位
        span.validation-label(v-if="active") 必須
      .right-side
        slot(name="question")

    .register-value.group-use-type-radios(:class="[ { 'non-active': !active } ]")
      label.register-radio-label(v-if="1 <= planType")
        input#group-use-type-0.register-radio-form(
          v-model="_value"
          :name="name"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="面会スケジュールの単位"
          :disabled="!active")
        span.register-radio-text 施設全体
      label#disable-group-use-type-0.register-radio-label(v-show="planType < 1")
        span.register-radio-text 施設全体
      b-popover(target="disable-group-use-type-0" triggers="hover" placement="top")
        template(v-slot:title) 面会スケジュールの単位
        span ※ ライトプラン以上で設定可能

      label.register-radio-label(v-if="1 <= planType")
        input#group-use-type-1.register-radio-form(v-model="_value" :name="name" type="radio" :value="1" :disabled="!active")
        span.register-radio-text 利用者グループ（例えばフロア）
      label#disable-group-use-type-1.register-radio-label(v-show="planType < 1")
        span.register-radio-text 利用者グループ（例えばフロア）
      b-popover(target="disable-group-use-type-1" triggers="hover" placement="top")
        template(v-slot:title) 面会スケジュールの単位
        span 利用者グループごとに異なる面会日程を作成できます。
        br
        span ※ ライトプラン以上で設定可能

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { userStore } from "@/store/store";
import { PlanType } from "@/commons/services/Plans";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputGroupUseType extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Number })
  value!: number;

  /** 活性にするか否か */
  @Prop({ default: true })
  active!: boolean;

  @Prop({ default: "group-use-type" })
  name!: string;

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }

  public mounted(): void {
    this.planType = userStore.facility.planType;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

// ラジオボタンは横幅に応じてラップする
.group-use-type-radios {
  flex-wrap: wrap;
}
.right-side {
  margin-left: 8px;
}

.group-use-type-radios.non-active {
  .register-radio-text {
    color: $btn-font-disable !important;
    cursor: not-allowed !important;

    &:hover {
      background: $bg-default !important;
    }
  }
  .register-radio-form:checked + .register-radio-text {
    background: $btn-disable !important;
    color: $btn-font-disable !important;
    border: 1px solid $btn-disable !important;
  }
}
.non-active-font {
  color: $form-border-color;
}
</style>
